<template>
  <div class="orders-by-type-chart">
    <apexchart
      type="donut"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'OrdersByTypeChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
    showValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'donut',
          height: 350,
        },
        labels: this.labels,
        colors: ['#3c58e7', '#f54526', '#5c11a2', '#f5c826'],
        legend: {
          position: 'bottom',
        },
        plotOptions: {
          pie: {
            donut: {
              size: '65%',
              labels: {
                show: true,
                total: {
                  show: true,
                  label: 'Total',
                  formatter: () => {
                    if (this.showValue) {
                      const total = _.sumBy(this.data, 'totalValue')
                      return '$' + (total / 1000).toFixed(0) + 'k'
                    }
                    const total = _.sumBy(this.data, 'count')
                    return total
                  },
                },
              },
            },
          },
        },
        tooltip: {
          y: {
            formatter: (val) => {
              if (this.showValue) {
                return '$' + val.toLocaleString()
              }
              return val + ' orders'
            },
          },
        },
      }
    },
    labels() {
      return _.map(this.data, (d) => d._id || 'Unknown')
    },
    series() {
      return _.map(this.data, (d) => {
        return this.showValue ? d.totalValue || 0 : d.count
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



